import { Category, SaleableSeat, FileMediaData, YoutubeVideo, Link } from "../models"

export class Event {
	public static LIFECYCLE_PHASES = {
		ON_EDIT: {
			phase: "ON_EDIT",
			name: "in Bearbeitung"
		},
		ON_SALE: {
			phase: "ON_SALE",
			name: "zum Verkauf freigegeben"
		},
		SUSPENDED: {
			phase: "SUSPENDED",
			name: "Verkauf unterbrochen"
		},
		FINISHED: {
			phase: "FINISHED",
			name: "abgeschlossen"
		},
		CANCELED: {
			phase: "CANCELED",
			name: "abgesagt"
		}
	}

	public storageId: string;
	public uuid: string;
	public merchantId: string;
	public seatingplanUuid: string;
	public venueId: number;
	public title: string;
	public subtitle: string;
	public begin: string;
	public end: string;
	public doorsOpenOffset: number;
	public startOfSale: string;
	public eventNotes: string;
	public description: string;
	public eventManager: string;
	public youTubeVideos: YoutubeVideo[];

	public userSetHasVisualQuota: boolean;

	public ticketAllocationNames: string[];
	public lifecyclePhase: string;
	public lifecycleHistory: string[];
	public images: FileMediaData[];
	public miscFiles: FileMediaData[];
	public _links: {
		self: Link
		categories: Link
		ticketQuotas: Link
		transitionLifecycle: Link
		cancel: Link,
		eventCategory: Link
		additionalCharges: Link
	}

	public releasedForDistribution: boolean;
	public disabledDistributionChannels: string[];
	public costCenter: string;
	public disabledShipmentTypes: string[];
	public testEvent: boolean;
	public seasonEvent: boolean;
	public personalizeTkts: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/event.model.ts